app.directive("acLayoutOnVisible", ['$rootScope', function($rootScope) {
    return {
        compile: function(element, attributes) {
            return {
                pre: function(scope, element, attributes) {
                    scope.$watch(function() { return angular.element(element).is(':visible') }, function() {
                            var mdcElement = element.children()[0]
                            var type = attributes.acLayoutOnVisible;
                            var isInDialog = attributes.acInDialog;
                            var maxHeight = attributes.acDropdownsearchMaxHeight;
                            
                            if(type === "MDCTextField"){
                                var mdcObject = new mdc.textField.MDCTextField(mdcElement);
                                mdcObject.layout();
                            }else if(type === "ACDropDownSearch"){
                                
                                var menuName = attributes.acSearch;
                                var menu = $(document).find("[ac-menu='"+menuName+"']");
                                var anchor = $("[ac-menu-anchor='"+menuName+"']")[0]

                                if($(anchor).hasClass("mdc-menu-surface--anchor")){
                                    var m = new mdc.menu.MDCMenu(menu[0])
                                    m.setAnchorElement(anchor)
                                    if(isInDialog != 'true'){
                                        m.hoistMenuToBody()
                                    }
                                    
                                    m.open = true;
                                    m.open = false;
                                    if(maxHeight != undefined){
                                        $(element).find(".mdc-menu").css("max-height", maxHeight)
                                    }
                                }
                                
                            }
                        });
                }
            }
        }
    }
}]);